import {
	hiprint
} from 'vue-plugin-hiprint'

export default function(options) {
	var addElementTypes = function(context) {
		// 移除 旧的 defaultModule "元素"类型, 以避免重复
		context.removePrintElementTypes("defaultModule");
		// 添加 defaultModule "元素"类型
		context.addPrintElementTypes("defaultModule", [
			// PrintElementTypeGroup 分组
			// 如果使用 hiprint.PrintElementTypeManager.build('.hiprintEpContainer2', "defaultModule") 这里会渲染这个 "常规" 分组名称
			new hiprint.PrintElementTypeGroup("常规", [{
				tid: "defaultModule.name", // 唯一 key
				type: "text", // 元素类型
				title: "商品名", // 这里和 options 中的 title 一样。"拖拽时就显示" 优先级高于 options 的, "无法彻底删除"
				// field: 'text' // 这里和 options 中的 field 一样。优先级高于 options 的, "无法彻底删除"
				// data: "1111", // 这里和 options 中的 testData 一样。会有冲突, "无法彻底删除"
				options: {
					title: "商品名", // 标题, "拖进设计器才会显示"
					field: "name", // 字段名称
					testData: "测试商品", // 测试数据
				},
			}, {
				tid: "defaultModule.unit", // 唯一 key
				type: "text", // 元素类型
				title: "计量单位", // 这里和 options 中的 title 一样。"拖拽时就显示" 优先级高于 options 的, "无法彻底删除"
				// field: 'text' // 这里和 options 中的 field 一样。优先级高于 options 的, "无法彻底删除"
				// data: "1111", // 这里和 options 中的 testData 一样。会有冲突, "无法彻底删除"
				options: {
					title: "计量单位", // 标题, "拖进设计器才会显示"
					field: "unit", // 字段名称
					testData: "个", // 测试数据
				},
			}, {
				tid: "defaultModule.format", // 唯一 key
				type: "text", // 元素类型
				title: "规格型号", // 这里和 options 中的 title 一样。"拖拽时就显示" 优先级高于 options 的, "无法彻底删除"
				// field: 'text' // 这里和 options 中的 field 一样。优先级高于 options 的, "无法彻底删除"
				// data: "1111", // 这里和 options 中的 testData 一样。会有冲突, "无法彻底删除"
				options: {
					title: "规格型号", // 标题, "拖进设计器才会显示"
					field: "format", // 字段名称
					testData: "测试型号", // 测试数据
				},
			}, {
				tid: "defaultModule.retailPrice", // 唯一 key
				type: "text", // 元素类型
				title: "零售价格", // 这里和 options 中的 title 一样。"拖拽时就显示" 优先级高于 options 的, "无法彻底删除"
				// field: 'text' // 这里和 options 中的 field 一样。优先级高于 options 的, "无法彻底删除"
				// data: "1111", // 这里和 options 中的 testData 一样。会有冲突, "无法彻底删除"
				options: {
					title: "零售价格", // 标题, "拖进设计器才会显示"
					field: "retailPrice", // 字段名称
					testData: "10", // 测试数据
				},
			}, {
				tid: "defaultModule.wholesalePricePrice", // 唯一 key
				type: "text", // 元素类型
				title: "批发价格", // 这里和 options 中的 title 一样。"拖拽时就显示" 优先级高于 options 的, "无法彻底删除"
				// field: 'text' // 这里和 options 中的 field 一样。优先级高于 options 的, "无法彻底删除"
				// data: "1111", // 这里和 options 中的 testData 一样。会有冲突, "无法彻底删除"
				options: {
					title: "批发价格", // 标题, "拖进设计器才会显示"
					field: "wholesalePricePrice", // 字段名称
					testData: "8", // 测试数据
				},
			}, {
				tid: "defaultModule.intoPrice", // 唯一 key
				type: "text", // 元素类型
				title: "采购价格", // 这里和 options 中的 title 一样。"拖拽时就显示" 优先级高于 options 的, "无法彻底删除"
				// field: 'text' // 这里和 options 中的 field 一样。优先级高于 options 的, "无法彻底删除"
				// data: "1111", // 这里和 options 中的 testData 一样。会有冲突, "无法彻底删除"
				options: {
					title: "采购价格", // 标题, "拖进设计器才会显示"
					field: "intoPrice", // 字段名称
					testData: "5", // 测试数据
				},
			}, {
				tid: "defaultModule.note", // 唯一 key
				type: "text", // 元素类型
				title: "备注", // 这里和 options 中的 title 一样。"拖拽时就显示" 优先级高于 options 的, "无法彻底删除"
				// field: 'text' // 这里和 options 中的 field 一样。优先级高于 options 的, "无法彻底删除"
				// data: "1111", // 这里和 options 中的 testData 一样。会有冲突, "无法彻底删除"
				options: {
					title: "备注", // 标题, "拖进设计器才会显示"
					field: "note", // 字段名称
					testData: "", // 测试数据
				},
			}]),
			new hiprint.PrintElementTypeGroup("辅助2", [{
				tid: "defaultModule.vline",
				title: "竖线",
				type: "vline",
			}]),
			new hiprint.PrintElementTypeGroup("辅助", [{
				tid: "defaultModule.hline",
				title: "横线",
				type: "hline",
			}]),
			new hiprint.PrintElementTypeGroup("条码", [{
				tid: "defaultModule.barcode",
				title: "条码",
				type: "barcode",
				options: {
					title: "商品条码", // 标题, "拖进设计器才会显示"
					field: "code", // 字段名称
					testData: "1234567891011", // 测试数据
				}
			}])
		])
	};
	return {
		addElementTypes: addElementTypes,
	};
}